<template>
  <el-dialog :visible.sync="visible" width="570px" class="common-dialog-class" :close-on-click-modal="false"
    @close="handleClose" @open="getOrgMenus">
    <div class="dialog-member-wrap">
      <div class="dialog-member-title">
        <span class="dialog-member-name">{{ form.id ? '查看角色' : '添加角色' }} </span>
        <div class="dialog-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="dialog-form-wrap auth-wrap">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="80px"
          class="demo-form auth-form">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="角色名称" prop="name">
                <el-input v-model="form.name" placeholder="请填写角色名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色备注" prop="mark">
                <el-input v-model="form.mark" placeholder="请填写角色备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="permit">
          <p>菜单权限</p>
          <el-tree :data="treeData" ref="roleTree" show-checkbox node-key="id" default-expand-all
            @check="handleTreeCheck" :default-checked-keys="form.menuIds" :props="defaultProps">
          </el-tree>
        </div>
        <div class="permit">
          <p>按钮权限</p>
          <el-checkbox-group v-model="form.buttonIds">
            <el-checkbox :label="item.id" v-for="(item, index) in buttonsList" :key="index">{{ item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="permit">
          <p>数据权限</p>
          <el-radio-group v-model="form.dataPermission">
            <el-radio :label="true">全部用户数据</el-radio>
            <el-radio :label="false">部分用户数据</el-radio>
          </el-radio-group>
        </div>
        <div class="common-dialog-foot-class" style="margin-top: 0">
          <el-button class="common-btn" @click="handleClose">取消</el-button>
          <el-button class="common-btn" type="primary" @click="submitForm">确认</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { seachorgmenus, addorgroles } from '@/api/settings.js'

export default {
  name: 'AuthorityDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm()
      }
    },
    editData(val) {
      if (val && Object.keys(val).length > 0) {
        this.form = JSON.parse(JSON.stringify(val))
      }
    }
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        mark: '',
        dataPermission: true,
        buttonIds: [],
        menuIds: []
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: ['click', 'change', 'blur'] },
        ],
        mark: [
          { required: true, message: '请输入角色备注', trigger: ['click', 'change', 'blur'] },
        ],
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      buttonsList: []
    }
  },
  methods: {
    initForm() {
      this.form = {
        id: '',
        name: '',
        mark: '',
        dataPermission: true,
        buttonIds: [],
        menuIds: []
      }
      if (this.editData && Object.keys(this.editData).length > 0) {
        this.form = JSON.parse(JSON.stringify(this.editData))
      }
    },
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.form.buttonIds = []
      this.form.menuIds = []
      this.$emit('close')
    },
    getOrgMenus() {
      seachorgmenus().then(res => {
        this.treeData = res.data.orgMenus
        this.buttonsList = res.data.orgButtons
      })
    },
    handleTreeCheck(val, node) {
      // 可选：如果需要外部获取选中状态，可以emit事件
    },
    submitForm() {
      let nodeChecked = this.$refs.roleTree.getCheckedKeys().concat(this.$refs.roleTree.getHalfCheckedKeys())
      if (!nodeChecked.length) {
        return this.$message.warning('菜单权限未选择！')
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          let reqData = {
            Id: this.form.id || '',
            Name: this.form.name,
            Mark: this.form.mark,
            MenuIds: nodeChecked,
            ButtonIds: this.form.buttonIds,
            DataPermission: this.form.dataPermission,
          }
          addorgroles(reqData).then(res => {
            if (res.code == 1) {
              if (this.form.id) {
                this.$message.success('修改成功！')
              } else {
                this.$message.success('添加成功！')
              }
              this.$emit('success', reqData)
              this.handleClose()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-member-wrap {
  padding: 20px;
}

.dialog-member-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.dialog-member-name {
  font-size: 16px;
  font-weight: bold;
}

.dialog-close {
  cursor: pointer;
  font-size: 20px;
  color: #999;
  
  &:hover {
    color: #666;
  }
}

.permit {
  margin-bottom: 20px;
  
  p {
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 18px;
    color: #606266;
  }
}

.auth-wrap {
  .auth-form {
    background: #fff;
    height: 42px;
    border-radius: 5px;
    padding: 6px;
  }

  ::v-deep .el-tree {
    background: transparent;

    .el-icon-caret-right {
      &::before {
        display: none;
      }
    }

    .el-tree-node__children {
      display: flex;
      flex-wrap: wrap;

      .el-tree-node {
        display: inline-block;
      }
    }

  }
}
</style>
